import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Lottie from "lottie-react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import "./payment-summary.scss";
import ModalPopUp from "../../components/modal/modal";

import Image from "../../components/image/image";
import Header from "../../components/header/header";
import EnquiryImg from "../../assets/enquiryImg.svg";
// import ScratchCardImg from "../../assets/scratchCardImg.svg";
import ArrowIcon from "../../assets/rightArrowIcon.svg";
import Loader from "../../components/loader/loader";
import SuccessIcon from "../../assets/PaymentSuccess.json";
import Error from "../../assets/PaymentFail.json";

import PaymentSummaryAPI from "../../services/PaymentSummary/PaymentSummary";
import GetWalletPointsAPI from "../../services/GetWalletPoints/GetWalletPoints";
import GetCampaignInfo from "../../services/CampaignInfo/CampaignInfo";
import rewardsValidation from "../../services/rewardsValidation/rewardsValidation";
import GetCampaignRewardType from "../../services/GetCampaignRewardType/GetCampaignRewardType";
import { pageUrl } from "../../utils/pageConstant";
import { statusCode } from "../../services/apiConstants";
import giftImage from "../../assets/scratchCrad/giftImage.png";
// import ScratchCardComponent from "../../components/scratch-card/scratch-card";

const PaymentSuccess = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [paymentSummary, setPaymentSummary] = useState();
  const [rewardID, setRewardID] = useState(0);
  const [isLoader, setIsLoader] = useState(false);
  const [walletPoints, setWalletPoints] = useState(0);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [message, setMessage] = useState({});
  const [statusIcon, setStatusIcon] = useState({});
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [isRewardVisible, setIsRewardVisible] = useState(false);
  const [rewardIsScratchcard, setRewardIsScratchcard] = useState(false);
  const [rewardIsSpin, setRewardIsSpin] = useState(false);
  const [campaignIdValue, setCampaignIdValue] = useState('');
  const [rewardMessage, setRewardMessage] = useState(null);

  const outletDetailsInfo = JSON.parse(
    localStorage.getItem("outletDetailsInfo")
  );

  useEffect(() => {
    return () => {
      // Clean up the class in case the component unmounts while the modal is open
      document.body.classList.remove('no-scroll');
    };
  }, []);

  useEffect(() => {
    const storedPaymentSummary = sessionStorage.getItem('paymentSummary');
  
    if (storedPaymentSummary) {
      setPaymentSummary(JSON.parse(storedPaymentSummary));
      sessionStorage.removeItem('paymentSummary');
    } else {
      //const orderId = 'BGTDD54622';
      const orderId = location?.state?.orderID;
      const bookingInfo = location?.state?.bookingInfo;
      if (bookingInfo) {
        console.log("Inside booking info loop...");
        setPaymentSummary(bookingInfo);
        //Hide rewards banner here..
      }
      if (orderId) {
        getPaymentSummary(orderId);
        console.log("Inside orderID loop...");
        //Below code is to handle the system back button navigation
        window.history.pushState(null, '', '/outlet-list'); 
        window.addEventListener('popstate', handleBack);
        return () => {
          window.removeEventListener('popstate', handleBack);
        };
      }
    }
    getWalletPoints();
  }, [location]);

  const rewardsTokenValidation = async () => {
    try{
       let response = await rewardsValidation();
       if(response) {
        let newToken = response?.data?.token;
        return newToken;
       } else {
        console.log("No response found for rewardsTokenValidation API!!");
        return null;
       }
    } catch(e) {
      console.log("Reward Validation Token API error :",e);
      return null;
    }
  }

  const getRewardType = async (token, campaignId) => {
    try{
      let res = await GetCampaignRewardType(token, campaignId);
      if(res){
        let campaignType = res?.data?.type;
        return campaignType;
      } else {
        console.log("No response found for getRewardType API!!");
        return null;
      }
    } catch(e) {
      console.log("Error while calling getRewardType API :",e);
      return null;
    }
  }

  const getPaymentSummary = async (orderId) => {
    setIsLoader(true);
    try {
      const responseData = await PaymentSummaryAPI(orderId);
      console.log("Payment Summary Response:",responseData)
      if (responseData && responseData.length > 0 && responseData[0] && responseData[0].length !== 0){
        let resInfo = responseData[0];
        let campaignID = resInfo?.campaignId;
        //let campaignID = 'CAMPAIGN_GIFTGREEN';
        setCampaignIdValue(campaignID);
        setPaymentSummary(responseData[0]);

        //------------------- For the Rewards Banner ----------------------
        // if(campaignID) {
        //   //setIsRewardVisible(true);
        //   let rewardToken = await rewardsTokenValidation();
        //   if(rewardToken) {
        //     let rewardType = await getRewardType(rewardToken, campaignID);
        //     if(rewardType === 'spin'){
        //       setIsRewardVisible(true);
        //       setRewardIsSpin(true);
        //       console.log("Reward is spin!!");
        //     } else if(rewardType === 'scratchcard') {
        //       fetchCampaignInfo(campaignID, resInfo?.localCouponDetails[0]?.totalAmtPaid, resInfo?.localCouponDetails[0]?.tranasctionId, resInfo?.localCouponDetails[0]?.orderDate, rewardToken)
        //       console.log("Reward is scratchcard!!");
        //     } else {
        //       setIsRewardVisible(false);
        //       console.log("Reward type isn't spin/scratch :", rewardType);
        //     }
        //   }
        // }
        setIsLoader(false);
      }else{
        setIsModalOpen(true);
        setStatusIcon({ icon: Error });
        setMessage({
          title: "Error!",
          text: "Error fetching data..",
        });
      }
    } catch (error) {
      setIsLoader(false);
      console.log("paymentSummary Error", error);
      setIsModalOpen(true);
      setStatusIcon({ icon: Error });
      setMessage({
        title: "Error!",
        text: "Cannot fetch data..",
      });
    } 
  };

  const getWalletPoints = async () => {
    try {
      const responseData = await GetWalletPointsAPI();
      setWalletPoints(responseData?.walletPoints);
      console.log("Wallet API Response :",responseData)
    } catch (error) {
      console.log("wallet points---", error);
    }
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    navigate("/outlet-list");
  };

  // const openModal = () => {
  //   setModalIsOpen(true);
  //   document.body.classList.add('no-scroll');
  // };

  // const closeModal = () => {
  //   setModalIsOpen(false);
  //   document.body.classList.remove('no-scroll');
  // };

  const fetchCampaignInfo = async (campaignNo, paidAmt, tranId, tranDate, rewardsToken) => {
    //let campID ='CAMPAIGN_74647';
    let customerID = sessionStorage.getItem("customerID") || 0;
    let bankName = sessionStorage.getItem("bankName") || '';
    try{
      const responseData = await GetCampaignInfo(campaignNo, customerID, bankName, paidAmt, tranId, tranDate, rewardsToken);
      if(responseData?.message === "BETTER LUCK NEXT TIME"){
        setIsRewardVisible(true);  //Show the rewards banner
        setRewardIsScratchcard(true);  //Ensure scratch card logic applies
        setRewardMessage(responseData.message); //Reward msg to be passed to scratchcard
      }else if(responseData?.success === true) {
        if(responseData?.data?.rewardId && responseData?.data?.rewardId != null && responseData?.data?.rewardId != ""){
          setRewardID(responseData?.data?.rewardId);
          setIsRewardVisible(true);
          setRewardIsScratchcard(true);
          setRewardMessage(null);
        }else{
          setIsRewardVisible(false);
        }
      }else{
        setIsRewardVisible(false);
      }
      console.log("Campaign API response :",responseData);
    }catch(e){
      console.log("Error while fetching campaign details :",e);
    }
  }

  const openScrachCard = () => {
    //let rewardNo = 5544;
    let validationToken= sessionStorage.getItem('token');
    let returnURL="https://dineinstage.z29.web.core.windows.net/payment-summary";

    // Store paymentSummary in sessionStorage
    if (paymentSummary) {
      sessionStorage.setItem('paymentSummary', JSON.stringify(paymentSummary));
    }

    if(rewardIsScratchcard && validationToken) {
      //window.location.href=`https://scratchcardpwasg.z29.web.core.windows.net/?rewardID=${rewardID}&isRedirected=true&returnURL=${returnURL}&token=${validationToken}`;

      let scratchCardURL = `https://scratchcardpwasg.z29.web.core.windows.net/?isRedirected=true&returnURL=${returnURL}&token=${validationToken}`;

      if (!rewardMessage && rewardID) {
        scratchCardURL += `&rewardID=${rewardID}`;
      } else {
        scratchCardURL += `&message=${encodeURIComponent(rewardMessage)}&isRewardMsg=true`;
      }
  
      window.location.href = scratchCardURL;
      
    } else if(rewardIsSpin) {
      window.location.href=`https://spinthewheelsg.z29.web.core.windows.net/?campaignId=${campaignIdValue}&isRedirected=true&returnURL=${returnURL}`;
    }
  }

  const handleNext = (paymentSummary) => {
    navigate(pageUrl.FEEDBACK, {
      state: { 
        outletID: paymentSummary?.outletId,
        paymentDetails: paymentSummary
       },
    });
  };

  const handleHomeBtnClick = () => {
    navigate("/outlet-list");
  }

  const handleBack = () => {
    outletDetailsInfo &&  outletDetailsInfo?.outletId
    ? navigate("/outlet-list") : navigate("/order-history");
  };

  const handleHelp = () => {
    navigate("/help");
  };

  const formatSavedAmount = (amount) => {
    if (amount === 0) {
        return "0";
    }
    return amount.toFixed(1).replace(/\.0$/, '');
  };

  const amountSaved = paymentSummary?.localCouponDetails[0]?.originalAmt - paymentSummary?.localCouponDetails[0]?.totalAmtPaid;
  const savedAmount = formatSavedAmount(amountSaved)


  // console.log("outletDetailsInfo", outletDetailsInfo);
  // console.log("OutletDetailsInfo - name :",outletDetailsInfo?.outletName);
  // console.log("Transaction ID :",paymentSummary?.localCouponDetails[0]?.transactionId || paymentSummary?.localCouponDetails[0]?.tranasctionId)
  return (
    <div className="payment-success-page">
      {isLoader ? (
        <Loader />
      ) : (
      <>
        <Header
          coin={walletPoints}
          onClick={handleBack}
          label={outletDetailsInfo?.outletName || "Order History"}
          // label={paymentSummary?.outletName}
          location={outletDetailsInfo?.locality}
        />
        <div className="bill-amount-success">
          <div className="top-section">
            <div className="left-side">
              <div className="bill-label">Bill amount</div>
              <div className="amount-label">
                <span>&#8377;</span>
                {paymentSummary?.localCouponDetails[0]?.originalAmt}
              </div>
              <div className="paid-date">
                Paid {paymentSummary?.localCouponDetails[0]?.orderDate}
              </div>
              <div className="paid-code">
                Code:{" "}
                {paymentSummary?.localCouponDetails[0]?.cardDetails[0]?.cardPin}
              </div>
            </div>
            <div className="right-side">
              <Lottie loop={true} animationData={SuccessIcon} />
            </div>
          </div>
          <div className="accordion" id="accordionExample">
            <Accordion defaultExpanded>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1-content"
                id="panel1-header"
                className="paid-success-msg"
              >
                <span>You paid &#8377;</span>
                {paymentSummary?.localCouponDetails[0]?.totalAmtPaid}
              </AccordionSummary>
              <AccordionDetails className="amount-split">
                <div className="bill-amount">
                  <span className="bill-text">Bill Amount</span>
                  <span>
                    <span>&#8377;</span>
                    {paymentSummary?.localCouponDetails[0]?.originalAmt}
                  </span>
                </div>
                <div className="discount-amount">
                  <span className="bill-text">Outlet Discount</span>
                  <span className="discount-bill">
                    <span>-&#8377;</span>
                    {paymentSummary?.localCouponDetails[0]?.discountedAmt}
                  </span>
                </div>
                {paymentSummary?.localCouponDetails[0]?.promoDiscountAmt ?
                  <div className="discount-amount">
                    <span className="bill-text">Coupon Discount</span>
                      <span className="discount-bill">
                        <span>-&#8377;</span>
                        {paymentSummary?.localCouponDetails[0]?.promoDiscountAmt}
                      </span>
                  </div>
                  :null
                }
                <div className="cashback-amount">
                  <span className="bill-text">Rewards</span>
                  <span className="cashback-bill">
                    <span>-&#8377;</span>
                    {paymentSummary?.localCouponDetails[0]?.walletAmtUsed}
                  </span>
                </div>
              </AccordionDetails>
            </Accordion>
          </div>
        </div>
        <div className="transaction-id">
          Transaction ID: {paymentSummary?.localCouponDetails[0]?.transactionId || paymentSummary?.localCouponDetails[0]?.tranasctionId}
        </div>
        {isRewardVisible?
          <div className="scratchCradSection">
            <div className="scratchCradDesign" onClick={openScrachCard}>
              <div className="scratchCardContent">
                <div className="cardLeftImg">
                  <img className="giftImg" src={giftImage} alt="gift" />
                </div>
                <div className="cardRightText">
                  <div className="textLineOne">You won a </div>
                  <div className="textLineTwo">Reward!! 🥳</div>
                </div>
              </div>
            </div>
          </div>
        : null}
        {/* <ScratchCardComponent 
          brandImage={"https://www.fastrack.in/on/demandware.static/-/Sites-titan-master-catalog/default/dw79a1943f/images/promotions/fastrack/Stunners6.0/Stunners_6_5.jpg"}
          modalIsOpen={modalIsOpen}
          closeModal={closeModal}
          cardType={"coupon"} //coupon or cashback
          minAmt={50}
          maxAmt={100}
        /> */}
        <div className="saved-amount-msg">
          You saved <span>&#8377;</span>
          {savedAmount} on this bill.
        </div>
        <div className="review-btn" onClick={() => handleNext(paymentSummary)}>
          {"Write a Review"}
        </div>
        {outletDetailsInfo?.outletName &&
          <div className="review-btn" onClick={() => handleHomeBtnClick()}>
            {"Home"}
          </div>
        }
        {/* <Image src={ScratchCardImg} /> */}
        <div className="enquiry-section" onClick={handleHelp}>
          <div className="enquiry-texts">
            <div className="help-label">Need help with this bill? </div>
            <div className="enquiry-label">
              Enquiry <Image src={ArrowIcon} />
            </div>
          </div>
          <Image src={EnquiryImg} />
        </div>
        {isModalOpen && (
          <ModalPopUp
            isOpen={isModalOpen}
            handleModalClose={handleCloseModal}
            message={message}
            icon={statusIcon.icon}
          />
        )}
      </>
      )}
    </div>
  );
};

export default PaymentSuccess;
